import { API } from "../../../utils/api";

export const getUnitList = async ({ query, pagination }) => {
  const { pageIndex, pageSize } = pagination;
  const res = await API.get(
    `units?page=${pageIndex}&per_page=${pageSize}`,
    query
  );
  return res.data.data;
};
export const getUnitListData = async ({ query }) => {
  const res = await API.get(`units`, query);
  return res.data.data;
};
export const saveUnit = async (payload) => {
  const res = await API.post("units", payload);
  return res.data.data;
};

export const getUnit = async (id) => {
  const res = await API.get(`units/${id}`);
  return res.data.data;
};

export const editUnit = async (payload, detailsId) => {
  const res = await API.put(`units/${detailsId}`, payload);
  return res.data;
};

export const removeUnit = async (id) => {
  const res = await API.delete(`units/${id}`);
  return res.data;
};
